import { useEffect } from "react";
import {
  createBrowserRouter,
  RouterProvider,
  createRoutesFromElements,
  Route,
} from "react-router-dom";
//import ReactGA from "react-ga4";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import { Toaster } from "sonner";
import TagManager from "react-gtm-module"; //Hung

// styles
import "./style.scss";
import "@trussworks/react-uswds/lib/index.css";

// pages component
// import AdvancedSearchPage from "./pages/AdvancedSearch";
// import BasicSearchPage from "./pages/BasicSearch";
// import BusinessProfile from "./pages/BusinessProfile";
import LibraryPage from "./pages/Library";
import AdvancedSearchNewPage from "./pages/AdvancedSearchNew";
import AdvancedSearchV2 from "./pages/AdvancedSearchV2/AdvancedSearchV2";
import SamEntitySearch from "pages/SamEntitySearch/SamEntitySearch";
import SamEntityPage from "pages/SamEntityPage/SamEntityPage";
import HomePage from "pages/Home/Home";
import NotFoundPage from "pages/NotFoundPage/NotFoundPage";
// import MarketInsights from "pages/MarketInsights/MarketInsights";
import MarketInsights from "pages/MarketInsights/MarketInsights";
import BusinessProfileEdit from "pages/BusinessProfileEdit/BusinessProfileEdit";
import Meili from "pages/Meili/Meili";
import BusinessProfileDetails from "pages/BusinessProfileDetails/BusinessProfileDetails";
import EmailsExport from "pages/EmailsExport/EmailsExport";
import ClaimBusiness from "pages/ClaimBusiness/ClaimBusiness";
import VerifyBusiness from "pages/VerifyBusiness/VerifyBusiness";
import Accessibility from "pages/Accessibility/Accessibility";
import ParticipationAgreement from "pages/ParticipationAgreement/ParticipationAgreement";
import Error from "pages/Error/Error";

import InactivityHandler from "components/InactivityHandler";
import ProtectedRoute from "components/ProtectedRoute/ProtectedRoute";

// layouts
import MainLayout from "layouts/MainLayout/MainLayout";

// store
import useAuthStore from "store/useAuthStore";

const queryClient = new QueryClient();
const tagManagerArgs = {
  gtmId: process.env.REACT_APP_SBS_TRACKING_ID as string,
};

//Initialize Google Tag Manager
TagManager.initialize(tagManagerArgs);

const router = createBrowserRouter(
  createRoutesFromElements(
    <>
      <Route path="/" element={<MainLayout />} errorElement={<Error />}>
        <Route index element={<HomePage />} />

        <Route
          path={`/profile/:uei/:cage_code`}
          element={<BusinessProfileDetails />}
        />

        <Route
          path={`/profile/:uei/:cage_code/edit`}
          element={
            <ProtectedRoute>
              <BusinessProfileEdit />
            </ProtectedRoute>
          }
        />

        {/* <Route path={`/advanced`} element={<AdvancedSearchNewPage />} /> */}
        <Route path={`/advanced`} element={<AdvancedSearchV2 />} />

        <Route path={`/library`} element={<LibraryPage />} />

        <Route path={`/market-insights`} element={<MarketInsights />} />
        <Route path={`/meili`} element={<Meili />} />

        <Route path={`/emails-export`} element={<EmailsExport />} />
        <Route
          path={`/claim-business`}
          element={
            <ProtectedRoute>
              <ClaimBusiness />
            </ProtectedRoute>
          }
        />

        <Route
          path={`/verify-business`}
          element={
            <ProtectedRoute>
              <VerifyBusiness />
            </ProtectedRoute>
          }
        />

        <Route
          path={`/participation-agreement`}
          element={
            <ProtectedRoute>
              <ParticipationAgreement />
            </ProtectedRoute>
          }
        />

        <Route path={`/accessibility`} element={<Accessibility />} />


        <Route
          path={`/sam-entity`}
          element={
            <ProtectedRoute>
              <SamEntitySearch />
            </ProtectedRoute>
          }
        />

        <Route
          path={`/sam-entity/:uei/:cage_code?`}
          element={
            <ProtectedRoute>
              <SamEntityPage />
            </ProtectedRoute>
          }
        />

      </Route>
      <Route path="*" element={<NotFoundPage />} errorElement={<Error />} />
    </>
  )
);

export default function App() {
  /*
  useEffect(() => {
    ReactGA.send({
      hitType: "pageview",
      page: window.location.pathname,
      title: "SBA SBS Search",
    });
  }, []);
  */
  const { checkAuth } = useAuthStore();

  // Check auth on mount
  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  return (
    <QueryClientProvider client={queryClient}>
      <RouterProvider router={router} />

      <InactivityHandler />

      {process.env.NODE_ENV === "development" && (
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-left"
        />
      )}

      <Toaster
        position="top-right"
        richColors
        closeButton
        toastOptions={{
          duration: 2000,
          style: {
            padding: 16,
          },
        }}
      />
    </QueryClientProvider>
  );
}
